import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/clCommunityData';

export default function Footer() {
  return (
    <footer className="bg-background-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-heading font-bold text-base">CL</span>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              发现优质内容，连接活跃圈子。<br />让有价值的交流发生在每个人身边。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">热门板块</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">首页</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">关于我们</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">帮助中心</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">社区规范</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-background-400">
              <span>邮箱：contact@clshequ.com</span>
              <span>微信：CL社区官方号</span>
              <span>微博：@CL社区官方</span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2018-2026 {siteInfo.name} 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">用户协议</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}